import { useMutation } from '@tanstack/react-query';
import { apiClientV2 } from '~/api/client';

export function useExportToCSV(listId: string) {
  return useMutation({
    mutationFn: () => apiClientV2.post(`/saved-lists/${listId}/export/csv`),
  });
}
